import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchScreen, none } from './searchScreen';

interface SearchState {
  viewModel: SearchScreen.ViewModel;
}

const initialState: SearchState = {
  viewModel: none(''),
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<SearchScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = searchSlice.actions;

export default searchSlice.reducer;
